import { generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

import { processMenu } from '../utils/menu';

/**
 * Get the Compliance menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 * }} params
 * @returns {Array}
 */
export function getComplianceMenuItems({ businessEntityUuid, entitlements }) {
  return [
    {
      order: 10,
      show: entitlements.has('virtual_business_address'),
      title: 'Virtual Mailing Address',
      path: generatePath(ROUTES.virtualBusinessAddress, { businessEntityUuid })
    },
    {
      order: 20,
      show: entitlements.has('amendments'),
      title: 'Amendments',
      path: generatePath(ROUTES.amendments, { businessEntityUuid })
    },
    {
      order: 30,
      show: entitlements.has('annual_reports'),
      title: 'Annual Reports',
      path: generatePath(ROUTES.annualReports, { businessEntityUuid })
    },
    {
      order: 40,
      title: 'Worry Free Compliance',
      path: generatePath(ROUTES.worryFreeCompliance, { businessEntityUuid })
    }
  ];
}

/**
 * Get the compliance menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getComplianceMenu({ businessEntityUuid, entitlements, order }) {
  return processMenu({
    title: 'Compliance',
    icon: 'tag-fill.svg',
    links: getComplianceMenuItems({ businessEntityUuid, entitlements }),
    order
  });
}
